import axios, { AxiosPromise } from 'axios';

const BASE = 'api/menuFavoritos';

/** `href` de las pantallas marcadas con estrella por el usuario con sesión. */
export function getMenuFavoritos(): AxiosPromise<string[]> {
    return axios.get(BASE);
}

/** Reemplaza la lista completa; el backend devuelve la lista guardada. */
export function setMenuFavoritos(favoritos: string[]): AxiosPromise<string[]> {
    return axios.put(BASE, { favoritos });
}
